<template>
  <div>
    <div class="row row--primary">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1">
        <vue-compare-image
          v-if="packageHasCompareImages"
          :left-image="beforeImageUrl"
          :right-image="afterImageUrl"
          :reset-param="retouchingPackage.OfferPackageID"
          :slider-position-percentage="0.6"
        />
      </div>
    </div>
    <div class="row row--secondary">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1">
        <div class="row row--retail-name">
          <div class="col-xs-12">
            <h3 class="retail-name">{{ retouchingPackage.CatalogPackage.RetailName }}</h3>
            <sidebar-cta-buttons
              :retouching-package="retouchingPackage"
              :selected-retouchings="selectedRetouchings"
              :frame-id="frameId"
              :content="content"
              class="visible-xs"
              @retouching-added="addRetouching"
              @retouching-removed="removeRetouching"
            />
            <div
              class="visible-xs retail-summary"
            >{{ retouchingPackage.CatalogPackage.RetailSummary }}</div>
          </div>
        </div>
        <sidebar-cta-buttons
          :retouching-package="retouchingPackage"
          :selected-retouchings="selectedRetouchings"
          :retouchings-in-cart="retouchingsInCart"
          :frame-id="frameId"
          :content="content"
          class="hidden-xs"
          @retouching-added="addRetouching"
          @retouching-removed="removeRetouching"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueCompareImage from '../../VueCompareImage'
import ContentfulMixin from '@Shared/mixins/contentful'
import SidebarCtaButtons from './SidebarCtaButtons'

export default {
  name: 'RetouchingPackageSidebar',
  components: {
    VueCompareImage,
    SidebarCtaButtons
  },
  mixins: [ContentfulMixin],
  props: {
    retouchingPackage: { type: Object, default: null },
    frameId: { type: Number, default: null },
    retouchingsInCart: {
      type: Object,
      default: null
    },
    content: {
      type: Object,
      default: null
    },
    selectedRetouchings: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    packageHasCompareImages () {
      return (this.retouchingPackage.CatalogPackage.CmsPackageBeforeAfterDetail !== null &&
              this.retouchingPackage.CatalogPackage.CmsPackageBeforeAfterDetail.BeforeImage !== null &&
              this.retouchingPackage.CatalogPackage.CmsPackageBeforeAfterDetail.After !== null
      )
    },
    packagePreviewImage () {
      if (
        this.retouchingPackage.CatalogImageDetailUrl !== null &&
        this.retouchingPackage.CatalogImageDetailUrl.length > 0
      ) {
        return this.retouchingPackage.CatalogImageDetailUrl
      }

      if (
        this.retouchingPackage.ImageDetailUrl !== null &&
        this.retouchingPackage.ImageDetailUrl.length > 0
      ) {
        return this.retouchingPackage.ImageDetailUrl
      }

      return null
    },
    beforeImageUrl () {
      return this.retouchingPackage.CatalogPackage.CmsPackageBeforeAfterDetail.BeforeImage.File.Url
    },
    afterImageUrl () {
      return this.retouchingPackage.CatalogPackage.CmsPackageBeforeAfterDetail.AfterImage.File.Url
    }
  },
  methods: {
    addRetouching () {
      this.$emit('retouching-added', {
        frameId: this.frameId,
        offerPackageId: this.retouchingPackage.OfferPackageID
      })
    },
    removeRetouching () {
      this.$emit('retouching-removed', {
        frameId: this.frameId,
        offerPackageId: this.retouchingPackage.OfferPackageID
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.row--secondary,
.row--retail-name {
  margin-bottom: 10px;
}

.retail-name {
  font-weight: bold;
  font-family: $font-open-sans;
  margin-bottom: 20px;
}

.retail-summary {
  margin-top: 10px;
  font-family: $font-roboto;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/RetouchingModal/RetouchingPackageSidebar.vue